import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import owlLogo from '../Assets/logo icon transparent background.png';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-xl font-bold text-[#1d2840] mb-3">{title}</h2>
    <div className="text-gray-600 space-y-2">
      {children}
    </div>
  </div>
);

const BulletList = ({ items }) => (
  <ul className="list-none space-y-2 mt-2">
    {items.map((item, index) => (
      <li key={index} className="flex items-start">
        <span className="text-[#3DA3DC] mr-2">•</span>
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Header */}
      <div className="w-full bg-white shadow-sm sticky top-0 z-50">
        <header className="container mx-auto px-4 flex justify-between items-center py-5">
          <Link to="/" className="flex items-center">
            <img src={owlLogo} alt="SuperOwl Logo" className="h-14 md:h-16 mr-3" />
            <span className="text-[#1d2840] text-2xl md:text-3xl font-bold">Super</span>
            <span className="text-[#3DA3DC] text-2xl md:text-3xl font-bold">Owl</span>
          </Link>
        </header>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-[#1d2840] mb-4">Terms & Conditions</h1>
          <p className="text-gray-500 mb-8">Last Updated: 10-03-2025</p>
          
          <p className="text-gray-600 mb-8">
            Welcome to SuperOwl, a service provided by Beaut Group. By using our AI conversational chat services, 
            you agree to the following Terms & Conditions. Please read them carefully.
          </p>

          <div className="space-y-8">
            <Section title="1. Acceptance of Terms">
              <p>
                By accessing or using SuperOwl's AI-powered chat solutions, you agree to comply with these Terms. 
                If you do not agree, please do not use our services.
              </p>
            </Section>

            <Section title="2. Service Description">
              <p>
                SuperOwl provides AI conversational chat solutions designed for small and medium businesses (SMBs). 
                Our services include but are not limited to:
              </p>
              <BulletList items={[
                'AI chatbot setup and integration',
                'Automated customer engagement',
                'Customizable AI responses',
                'API-based AI chat services'
              ]} />
            </Section>

            <Section title="3. User Responsibilities">
              <p>By using SuperOwl, you agree to:</p>
              <BulletList items={[
                'Use the service lawfully and ethically.',
                'Ensure that your use of AI chat does not violate any regulations or third-party rights.',
                'Keep your login credentials secure and confidential.'
              ]} />
            </Section>

            <Section title="4. Fair Usage Policy">
              <p>
                SuperOwl aims to offer cost-effective AI chat solutions. While some features may be provided at 
                minimal or no cost, we reserve the right to introduce fair usage limits to maintain service quality. 
                Excessive usage beyond reasonable business needs may require an upgrade to a paid plan.
              </p>
            </Section>

            <Section title="5. Data Privacy & Security">
              <BulletList items={[
                'We prioritize user privacy and data protection.',
                'SuperOwl may collect and process data in accordance with our Privacy Policy.',
                'Users are responsible for ensuring that their use of AI chat complies with data protection laws applicable to their region.'
              ]} />
            </Section>

            <Section title="6. Limitations & Liability">
              <BulletList items={[
                'SuperOwl provides AI-powered responses, but we do not guarantee absolute accuracy. Users should verify critical information before relying on AI-generated responses.',
                'We are not responsible for any indirect, incidental, or consequential damages resulting from the use of our AI chat services.',
                'SuperOwl reserves the right to suspend or terminate services if any misuse, violation, or security threat is detected.'
              ]} />
            </Section>

            <Section title="7. Modifications to Terms">
              <p>
                We may update these Terms from time to time. Any changes will be posted on this page, and continued 
                use of our services after modifications constitutes acceptance of the updated Terms.
              </p>
            </Section>

            <Section title="8. Contact Information">
              <p>For questions or concerns regarding these Terms & Conditions, please contact us at:</p>
              <div className="mt-2 space-y-1">
                <p className="flex items-center">
                  <span className="mr-2">📧</span>
                  beautgroup@gmail.com
                </p>
                <p className="flex items-start">
                  <span className="mr-2">📍</span>
                  #5/1 First Floor, New Thippasandra, HAL 3rd Stage, Bangalore - 560075
                </p>
              </div>
            </Section>
          </div>

          <p className="mt-12 text-gray-600 text-center">
            By using SuperOwl, you acknowledge that you have read, understood, and agree to these Terms & Conditions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
